import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'membership_retention';
export const route = 'membership_retention/';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "membershipretention" */
'../../components/MembershipRetention')));